import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tabs,
  Tab,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import PropTypes from "prop-types";
import GroupsOwnedTab from "../GroupsOwnedTab/GroupsOwnedTab";
import GroupMembershipTab from "../GroupMembershipTab/GroupMembershipTab";

export function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            style={{
                backgroundColor: "white",
                // borderRadius: "12px",
            }}
        >
            {value === index && (
                <Box sx={{ p: 0 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </Box>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
}

function GroupLoansTab({ selectedUser, selectedUserData }) {
    const [groupsOwned, setGroupsOwned] = useState([]);
    const [groupMemberships, setGroupMemberships] = useState([]);
    const [tabIndex, setTabIndex] = useState(0);
    const [value, setValue] = useState(0);
    
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: "rgba(0,0,0, .1)",
        color: theme.palette.common.black,
            fontWeight: "bold",
            textAlign: "center",
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 25,
            fontWeight: "600",
        },
    }));

    useEffect(() => {
        // Fetch or inject data via props
        setGroupsOwned([
            {
                id: 1,
                name: "Savings Group A",
                terms: "Weekly contributions of $20",
                rules: "Must contribute weekly",
                balance: "$1200",
            },
            {
                id: 3,
                name: "Emergency Fund Group",
                terms: "Monthly contributions",
                rules: "Can withdraw only in emergencies",
                balance: "$890",
            },
        ]);

        setGroupMemberships([
            {
                id: 2,
                name: "Loan Group B",
                terms: "Monthly loan repayments",
                rules: "Late fees after 10 days",
                balance: "$300",
            },
        ]);
    }, [selectedUser]);

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const renderTable = (data) => (
        <TableContainer className="loan-approve-table-container">
            <Table>
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Group Name</StyledTableCell>
                        <StyledTableCell>Terms & Conditions</StyledTableCell>
                        <StyledTableCell>Group Rules</StyledTableCell>
                        <StyledTableCell>Balance</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((group) => (
                        <TableRow key={group.id}>
                        <TableCell align="center" className="">{group.name}</TableCell>
                        <TableCell align="center" className="">{group.terms}</TableCell>
                        <TableCell align="center" className="">{group.rules}</TableCell>
                        <TableCell align="right" className="">{group.balance}</TableCell>
                        </TableRow>
                    ))}
                    {data.length === 0 && (
                        <TableRow>
                        <TableCell colSpan={4} align="center">
                            No groups found
                        </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );

  return (
    <Box className="group-loans-tab-container" p={2}>
        <Box
            sx={{
                backgroundColor: "#f8f8f8",
                position: "sticky",
                top: 0,
                zIndex: 1,
            }}
        >
            <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                // TabIndicatorProps={{ style: { display: "none" } }}
                TabIndicatorProps={{
                    style: {
                      backgroundColor: 'transparent',
                    },
                    children: <span className="MuiTabs-indicatorSpan" />,
                  }}
                sx={{
                    '& .MuiTabs-indicator': {
                        display: 'flex',
                        justifyContent: 'center',
                        backgroundColor: 'transparent',
                        height:"3px !important",
                    },
                    '& .MuiTabs-indicatorSpan': {
                        maxWidth: 80, // Adjust to control width of yellow line
                        width: '100%',
                        backgroundColor: '#FAC800',
                        height: 1,
                        borderRadius: 2,
                    },
                    "& .MuiTab-root": {
                        textTransform: "capitalize",
                        color: "#BCBCBC",
                        fontFamily: "Inter",
                        fontSize: 15,
                        fontStyle: "normal",
                        fontWeight: 400,
                        // lineHeight: "30px",
                        backgroundColor: "#f8f8f8",
                        "&.Mui-selected": {
                            backgroundColor: "white",
                            // color: "#5523D2",
                            color: "#00365A",
                            borderRadius: "6px 6px 0 0 !important",
                            // textAlign: "center",
                            // fontSize: 15,
                            // fontStyle: "normal",
                            fontWeight: 600,
                            // lineHeight: "30px",
                            // borderBottom: 0,
                            // borderBottomColor: "#FAC800",
                            // borderBottomWidth: 4,
                        },
                    },
                }}
            >
                <Tab label="Groups Owned" {...a11yProps(0)} />
                <Tab label="Group Memberships" {...a11yProps(1)} />
            </Tabs>

            <CustomTabPanel value={value} index={0} className="">
                <GroupsOwnedTab selectedUser={selectedUser} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1} className="">
                <GroupMembershipTab selectedUser={selectedUser} />
            </CustomTabPanel>
        </Box>
    </Box>
  );
}

export default GroupLoansTab;
